(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("avatar-cropper", [], factory);
	else if(typeof exports === 'object')
		exports["avatar-cropper"] = factory();
	else
		root["avatar-cropper"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'avatarCropper',

  props: {
    value: {
      default: true
    }
  },

  data: function data() {
    return {
      // 是否显示重新选择
      showRechoose: false,
      // 存储用户选择的图片
      img: new Image(),

      // 图片画布的宽高
      canvasWidth: 450,
      canvasHeight: 450,

      // 缩放比例， 显示/实际
      scale: 1.0,

      // 缩放后起点坐标和宽高
      x: 0,
      y: 0,
      xLen: 0,
      yLen: 0,

      // 鼠标按下时的坐标
      mouseDownX: 0,
      mouseDownY: 0,

      // 鼠标是否正在按下
      // cropper内
      mouseIsDownCropper: false,
      // dot处
      mouseIsDownDot: false
    };
  },


  watch: {
    value: function value() {
      if (this.value && document.body.clientWidth < 768) {
        // 移动端开启此插件时禁止拖动和滚轮事件
        document.addEventListener('touchmove', this.avoidMove, { passive: false });
        document.addEventListener('mousewheel', this.avoidMove, false);
      } else {
        // 此插件关闭时enable拖动和滚轮事件
        document.removeEventListener('touchmove', this.avoidMove, { passive: false });
        document.removeEventListener('mousewheel', this.avoidMove, false);
      }
    }
  },

  methods: {
    // 用于移动端适配，禁止拖动
    avoidMove: function avoidMove(e) {
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
    },


    // 用于移动端适配， 设备宽度变化时调节画布宽高
    resizeCanvas: function resizeCanvas() {
      if (document.body.clientWidth < 768) {
        this.canvasWidth = this.canvasHeight = document.documentElement.clientWidth * 0.9;

        // 显示选择按钮，隐藏编辑面板
        document.getElementById('select').style.display = 'inline-block';
        document.getElementById('edit').style.display = 'none';
      }
    },


    // 弹出选择文件窗口
    selectImg: function selectImg() {
      document.getElementById('inputFile').click();
    },


    // 当用户选择文件后调整显示的图片和蒙版
    changeImg: function changeImg(e) {
      var _this = this;

      var img = e.target.files[0];
      // 限制图片不超过5M
      if (img && img.size <= 5 * 1024 * 1024) {
        // 隐藏选择按钮，显示编辑面板
        document.getElementById('select').style.display = 'none';
        document.getElementById('edit').style.display = 'block';
        this.showRechoose = true;

        // 获取用户选择的图片数据
        var reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = function () {
          // 修改显示的图片数据
          _this.img.src = reader.result;
          // 显示图片
          _this.showImg();
        };
      } else {
        // 超过5M提醒
        alert('图片不可以超过5M！');
      }
    },


    // 显示图片
    showImg: function showImg() {
      var _this2 = this;

      this.img.onload = function () {
        // 缩放比以较长的那个边为准
        var widthIsLarger = _this2.img.width >= _this2.img.height;
        _this2.scale = widthIsLarger ? _this2.canvasWidth / _this2.img.width : _this2.canvasHeight / _this2.img.height;

        // 计算显示图片的左上角坐标和缩放后宽高
        _this2.xLen = _this2.img.width * _this2.scale;
        _this2.yLen = _this2.img.height * _this2.scale;
        _this2.x = (_this2.canvasWidth - _this2.xLen) / 2;
        _this2.y = (_this2.canvasHeight - _this2.yLen) / 2;

        // 显示缩放后的图片
        var ctx = document.getElementById('pic').getContext('2d');
        ctx.clearRect(0, 0, _this2.canvasWidth, _this2.canvasHeight);
        ctx.drawImage(_this2.img, 0, 0, _this2.img.width, _this2.img.height, _this2.x, _this2.y, _this2.xLen, _this2.yLen);

        // 显示蒙版
        _this2.showMask();
      };
    },


    // 显示蒙版
    showMask: function showMask() {
      // 调整蒙版位置
      var mask = document.getElementById('mask');
      mask.style.left = this.x + 'px';
      mask.style.top = this.y + 'px';
      mask.style.width = this.xLen + 'px';
      mask.style.height = this.yLen + 'px';
    },


    // 更新鼠标坐标
    updateMouseDownPos: function updateMouseDownPos(e) {
      this.mouseDownX = e.clientX;
      this.mouseDownY = e.clientY;
    },


    // 按下鼠标时记录鼠标坐标并更新mouseIsDown
    mousedownCropper: function mousedownCropper(e) {
      if (this.mouseIsDownCropper) return;
      this.updateMouseDownPos(e);
      this.mouseIsDownCropper = true;
    },
    mousedownDot: function mousedownDot(e) {
      if (this.mouseIsDownDot) return;
      this.updateMouseDownPos(e);
      this.mouseIsDownDot = true;
    },


    // 松开鼠标时更新mouseIsDown为false,结束拖动
    mouseup: function mouseup() {
      this.mouseIsDownCropper = this.mouseIsDownDot = false;
    },


    // 移动cropper
    moveCropper: function moveCropper(e) {
      if (this.mouseIsDownCropper) {
        var _cropper = document.getElementById('cropper');
        var cropperLen = Number(window.getComputedStyle(_cropper).getPropertyValue('width').slice(0, -2));
        var cropperTop = Number(window.getComputedStyle(_cropper).getPropertyValue('top').slice(0, -2));
        var cropperLeft = Number(window.getComputedStyle(_cropper).getPropertyValue('left').slice(0, -2));
        // 移动端适配
        if (!e.clientX) e = e.touches[0];
        var offsetX = e.clientX - this.mouseDownX;
        var offsetY = e.clientY - this.mouseDownY;
        this.updateMouseDownPos(e);
        /* 当
         * 0 <= top + len + offsetY <= yLen
         * 0 <= left + len + offsetX <= xLen
         * 时，移动cropper
         */
        var newTop = cropperTop + offsetY;
        var newLeft = cropperLeft + offsetX;
        if (newTop >= 0 && newTop + cropperLen <= this.yLen && newLeft >= 0 && newLeft + cropperLen <= this.xLen) {
          _cropper.style.top = newTop + 'px';
          _cropper.style.left = newLeft + 'px';
        }
      }
    },


    // 修改cropper大小
    resizeCropper: function resizeCropper(e) {
      if (this.mouseIsDownDot) {
        /*
         * resize优先，因此在mouseIsDownDot为true时
         * 设mouseIsDownCropper为false
         */
        this.mouseIsDownCropper = false;
        var _cropper2 = document.getElementById('cropper');
        var cropperLen = Number(window.getComputedStyle(_cropper2).getPropertyValue('width').slice(0, -2));
        var cropperTop = Number(window.getComputedStyle(_cropper2).getPropertyValue('top').slice(0, -2));
        var cropperLeft = Number(window.getComputedStyle(_cropper2).getPropertyValue('left').slice(0, -2));
        if (!e.clientX) e = e.touches[0];
        var offsetX = e.clientX - this.mouseDownX;
        // const offsetY = e.clientY - this.mouseDownY
        this.updateMouseDownPos(e);
        /* 当
         * len + offsetX >= 30
         * top + len + offsetX <= yLen
         * left + len + offsetX <= xLen
         * 时，resize cropper
         */
        if (cropperLen + offsetX >= 30 && cropperTop + cropperLen + offsetX <= this.yLen && cropperLeft + cropperLen + offsetX <= this.xLen) {
          // 宽高均为len + offsetX
          _cropper2.style.width = _cropper2.style.height = cropperLen + offsetX + 'px';
          // border-radius为宽高的一半
          _cropper2.style.borderRadius = (cropperLen + offsetX) / 2 + 'px';
        }
      }
    },


    // 用户选定后，传出选定的dataUrl
    ok: function ok() {
      if (!this.img.src) {
        // 如果未选择图片
        alert('请先选择图片！');
        return;
      }
      this.close();
      var x = Number(window.getComputedStyle(cropper).getPropertyValue('left').slice(0, -2)) / this.scale;
      var y = Number(window.getComputedStyle(cropper).getPropertyValue('top').slice(0, -2)) / this.scale;
      var length = Number(window.getComputedStyle(cropper).getPropertyValue('width').slice(0, -2)) / this.scale;
      var canvas = document.createElement('canvas');
      canvas.width = canvas.height = length;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(this.img, x, y, length, length, 0, 0, length, length);
      // 压缩
      this.$emit('ok', canvas.toDataURL('image/jpeg', 0.5));
    },


    // 关闭本插件
    close: function close() {
      this.$emit('input', false);
    }
  },

  mounted: function mounted() {
    this.resizeCanvas();
    window.addEventListener('resize', this.resizeCanvas, false);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeCanvas, false);
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__avatarCropper_vue__ = __webpack_require__(2);




var VueAvatarCropper = {
  install: function install(Vue) {
    Vue.component('avatar-cropper', __WEBPACK_IMPORTED_MODULE_0__avatarCropper_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (VueAvatarCropper);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatarCropper_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5bae42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatarCropper_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f5bae42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatarCropper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5bae42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatarCropper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1d068957", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "#container[data-v-0f5bae42]{position:fixed;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.3);user-select:none;z-index:9999}.panel[data-v-0f5bae42]{position:fixed;width:100vw;height:120vw;top:calc(50vh - 60vw);border-radius:5px;background-color:#fff}.buttons[data-v-0f5bae42]{width:100%;height:56px;margin-bottom:20px;background-color:#f2f2f5;text-align:center}.button[data-v-0f5bae42]{margin:11px 5px;padding:0 15px;border:0;border-radius:2px;height:34px;line-height:35px;background-color:#fff;color:#515a6e;font-size:14px;box-shadow:0 1px 2px rgba(0,0,0,.25);text-decoration:none;outline:none;cursor:pointer}.ok[data-v-0f5bae42]{background-color:#2d8cf0;color:#fff}.select-panel[data-v-0f5bae42]{width:90vw;height:90vw;margin:5vw;background-color:#f2f2f5}.hint[data-v-0f5bae42]{position:absolute;top:60px;width:90vw;text-align:center;color:#515a6e;font-size:12px}#select[data-v-0f5bae42]{position:absolute;left:calc(50vw - 43px);top:calc(60vw - 17px)}#edit[data-v-0f5bae42]{display:none;position:absolute;width:90vw;height:90vw;background-color:#333}#cropper[data-v-0f5bae42]{display:inline-block;position:absolute;top:0;left:0;width:100px;height:100px;border-radius:50px;box-shadow:0 0 0 500px hsla(0,0%,100%,.6);cursor:move}#dot[data-v-0f5bae42]{display:inline-block;position:absolute;top:50%;right:-4px;border:1px solid gray;width:7px;height:7px;border-radius:4px;background-color:#fff;cursor:w-resize}@media screen and (min-width:768px){.panel[data-v-0f5bae42]{width:500px;height:556px;top:calc(50vh - 270px);left:calc(50vw - 270px)}.select-panel[data-v-0f5bae42]{width:450px;height:450px;margin:25px;background-color:#f2f2f5}.hint[data-v-0f5bae42]{width:450px}#select[data-v-0f5bae42]{left:207px;top:250px}#edit[data-v-0f5bae42]{width:450px;height:450px}}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],attrs:{"id":"container"},on:{"mouseup":_vm.mouseup,"mouseleave":_vm.mouseup,"touchend":_vm.mouseup}},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"button",on:{"click":_vm.close}},[_vm._v("取消")]),_vm._v(" "),(_vm.showRechoose)?_c('button',{staticClass:"button",on:{"click":_vm.selectImg}},[_vm._v("重新选择")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button ok",on:{"click":_vm.ok}},[_vm._v("确定")])]),_vm._v(" "),_c('div',{staticClass:"select-panel"},[_c('div',{staticClass:"hint"},[_vm._v("只支持JPG、PNG、GIF、SVG，大小不超过5M")]),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"id":"select"},on:{"click":_vm.selectImg}},[_vm._v("选择图片")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"id":"inputFile","type":"file","accept":"image/gif,image/jpeg,image/jpg,image/png,image/svg"},on:{"change":_vm.changeImg}}),_vm._v(" "),_c('div',{attrs:{"id":"edit"}},[_c('canvas',{attrs:{"id":"pic","width":_vm.canvasWidth,"height":_vm.canvasHeight}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","overflow":"hidden"},attrs:{"id":"mask"},on:{"mousemove":_vm.resizeCropper,"touchmove":_vm.resizeCropper}},[_c('div',{attrs:{"id":"cropper"},on:{"mousedown":_vm.mousedownCropper,"mousemove":_vm.moveCropper,"touchstart":_vm.mousedownCropper,"touchmove":_vm.moveCropper}},[_c('div',{attrs:{"id":"dot"},on:{"mousedown":_vm.mousedownDot,"touchstart":_vm.mousedownDot}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// avatarCropper.js